import React from 'react'
import Translation from '../Translation/cont/Translation'

class DashboardIncompleteMoviesPanel extends React.Component {
    constructor(props) {
        super(props)
        this.state = { showIgnored: false }
    }

    render() {
        const { isOpen, movies, ignoredMovies, onClose, onIgnoreMovie, onUnignoreMovie } = this.props
        const { showIgnored } = this.state
        const ignoredCount = ignoredMovies ? ignoredMovies.length : 0

        const missingFields = [
            { show: movie => movie.missingFsk,         id: 'dashboard_panel_missing_fsk',         fallback: 'FSK missing' },
            { show: movie => movie.missingDescription, id: 'dashboard_panel_missing_description', fallback: 'Description missing' },
            { show: movie => movie.missingLength,      id: 'dashboard_panel_missing_length',       fallback: 'Duration missing' },
            { show: movie => movie.missingTrailer,     id: 'dashboard_panel_missing_trailer',      fallback: 'Trailer missing' },
            { show: movie => movie.missingLogo,        id: 'dashboard_panel_missing_logo',         fallback: 'Logo missing' },
            { show: movie => movie.missingImage,       id: 'dashboard_panel_missing_poster',       fallback: 'Poster missing' },
            { show: movie => movie.missingAmbient,     id: 'dashboard_panel_missing_ambient',      fallback: 'Ambient image missing' },
            { show: movie => movie.missingBackgrounds, id: 'dashboard_panel_missing_backgrounds',  fallback: 'Backgrounds missing' },
        ]

        const renderMovie = (movie, isIgnored) => {
            const activeMissingFields = missingFields.filter(field => field.show(movie))

            return (
                <div key={movie.id} className={`db-panel-item${isIgnored ? ' db-panel-item--ignored' : ''}`}>
                    <div
                        className={`db-pi-chip${movie.posterUrl ? ' db-pi-chip--has-image' : ''}`}
                        style={movie.posterUrl ? { backgroundImage: `url("${movie.posterUrl}")` } : undefined}
                    />
                    <div className="db-pi-body">
                        <div className="db-pi-film text-light">{movie.title}</div>
                        <div className="db-pi-miss text-small-light">
                            {activeMissingFields.map((field, index) => (
                                <React.Fragment key={field.id}>
                                    {index > 0 && ' · '}
                                    <Translation id={field.id}>{field.fallback}</Translation>
                                </React.Fragment>
                            ))}
                        </div>
                        <div className="db-pi-actions">
                            {!isIgnored && (
                                <a className="db-pi-link text-small-light" href={movie.editUrl}><Translation id="dashboard_panel_edit_link">→ Edit</Translation></a>
                            )}
                            {isIgnored
                                ? <span className="db-pi-unignore text-small-light" onClick={() => onUnignoreMovie(movie.id)}><Translation id="dashboard_panel_unignore">Unignore</Translation></span>
                                : <span className="db-pi-ignore text-small-light" onClick={() => onIgnoreMovie(movie.id)}><Translation id="dashboard_panel_ignore">Ignore</Translation></span>
                            }
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div className={`db-expand-panel db-expand-panel--warn${isOpen ? ' db-expand-panel--open' : ''}`}>
                <div className="db-panel-head">
                    <span className="db-panel-title text-small-light"><Translation id="dashboard_stat_incomplete_movies_label">Incomplete Movies</Translation></span>
                    <span className="db-panel-count text-small-light"><Translation id="dashboard_panel_movies_count" before={`${movies.length} `}>movies</Translation></span>
                    {ignoredCount > 0 && (
                        <span
                            className="db-panel-show-ignored text-small-light"
                            onClick={() => this.setState({ showIgnored: !showIgnored })}
                        >
                            {showIgnored
                                ? <Translation id="dashboard_panel_hide_ignored">Hide ignored</Translation>
                                : <Translation id="dashboard_panel_show_ignored" after={` (${ignoredCount})`}>Show ignored</Translation>
                            }
                        </span>
                    )}
                    <span className="db-panel-close text-small-light" onClick={onClose}>✕ <Translation id="button_close">Close</Translation></span>
                </div>
                <div className="db-panel-body">
                    <div className="db-panel-grid">
                        {movies.map(movie => renderMovie(movie, false))}
                    </div>

                    {showIgnored && ignoredCount > 0 && (
                        <div className="db-panel-ignored-section">
                            <div className="db-panel-ignored-label text-small-light"><Translation id="dashboard_panel_ignored_section">Ignored</Translation></div>
                            <div className="db-panel-grid">
                                {ignoredMovies.map(movie => renderMovie(movie, true))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default DashboardIncompleteMoviesPanel
